export default "__VITE_ASSET__0ff512b9__"